import script from "./PdAvatar.vue?vue&type=script&setup=true&lang=js"
export * from "./PdAvatar.vue?vue&type=script&setup=true&lang=js"

import "./PdAvatar.vue?vue&type=style&index=0&id=319fbc33&scoped=true&lang=css"

import exportComponent from "../../../paydeck-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-319fbc33"]])

export default __exports__